export const blockList = [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
];

export const allowList = [
    // `localhost`, // Only uncomment when needed for debugging new calls to Sentry. There is a test to protect against merging this
    `studio.grbydv.com`,
    `studio.grabyo.com`,
    `beta.grabyo.com`,
    `studio-staging.grabyo.com`,
    `staging.grabyo.com`,
    `staging1.grabyo.com`,
    `staging2.grabyo.com`,
    `staging3.grabyo.com`
];

export enum SentryEnvironment {
    LocalHost = `localhost`,
    Development = `development`,
    Staging = `staging`,
    Production = `production`
}

export const getSentryEnvironment = (host: string): SentryEnvironment => {
    if (host === `localhost`) {
        return SentryEnvironment.LocalHost;
    } else if (host.includes(`staging`) || host.includes(`beta`)) {
        return SentryEnvironment.Staging;
    } else if (host === `studio.grabyo.com`) {
        return SentryEnvironment.Production;
    }
    // Default to development
    return SentryEnvironment.Development;
};
